import React from 'react'
import moment from 'moment'

import PrevArrow from '../../../assets/icons/calendar-prev.svg'
import NextArrow from '../../../assets/icons/calendar-next.svg'

const CalendarHeader = ({ currentDate, handleNextMonth, handlePrevMonth }) => {
  let titleDateFormat = 'MMMM YYYY'

  if (process.env.REACT_APP_FORMAT_CALENDER_TITLE_DATE) {
    titleDateFormat = process.env.REACT_APP_FORMAT_CALENDER_TITLE_DATE
  }

  return (
    <div className="u-calendar__header">
      <div className="u-calendar__month-nav previous">
        <button onClick={handlePrevMonth}>
          <img src={PrevArrow} alt="Calendar Previous Month" />
        </button>
      </div>

      <div className="u-calendar__month">
        <h4>{moment(currentDate).format(titleDateFormat)}</h4>
      </div>

      <div className="u-calendar__month-nav next">
        <button onClick={handleNextMonth}>
          <img src={NextArrow} alt="Calendar Next Month" />
        </button>
      </div>
    </div>
  )
}

export default CalendarHeader
